import { useInfiniteQuery } from '@tanstack/react-query';
import { formatDate } from 'date-fns';
import { ILeadSearchView } from '../../aida/viewModels/leads/interfaces';
import { ImpersonationBroker, IPagedCollection } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/demosToConfirm';

export function useLeadDemosToConfirmQuery({
	pageSize = 25,
	userId,
	managerUserId,
	outcomeName,
	companyId,
	demoPerformerUserId,
	start,
	end,
	enabled,
	meta,
}: {
	userId?: string;
	managerUserId?: string;
	outcomeName?: string;
	demoPerformerUserId?: string;
	start?: Date;
	end?: Date;
	pageSize?: number;
	enabled?: boolean;
	companyId?: string;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		queryKey: [BASE_QUERY_KEY, userId, outcomeName, demoPerformerUserId, start, end, managerUserId, companyId],
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<ILeadSearchView>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: 'lead/demosToConfirm',
					queryParams: {
						pageSize,
						userId,
						outcomeName,
						demoPerformerUserId,
						start: start ? formatDate(start, 'yyyy-MM-dd') : undefined,
						end: end ? formatDate(end, 'yyyy-MM-dd') : undefined,
						managerUserId,
						companyId,
						pageToken: pageParam,
					},
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
		enabled,
		meta,
	});
}
